// src/components/Layout.jsx
import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const DRAWER_WIDTH = 0;
const MINI_WIDTH = 0;

export default function Layout() {
  // sidebar persist
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try {
      return localStorage.getItem("sidebar_open") !== "0";
    } catch (e) {
      return true;
    }
  });

  const toggleSidebar = () => {
    setSidebarOpen((s) => {
      const next = !s;
      try {
        localStorage.setItem("sidebar_open", next ? "1" : "0");
      } catch (e) {}
      return next;
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #f7fafc 0%, #eef3f8 48%, #eaf7f3 100%)",
      }}
    >
      {/* Fixed Header */}
      <Header onToggle={toggleSidebar} />

      {/* Sidebar */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: "78px", // header height
          ml: sidebarOpen ? `${DRAWER_WIDTH}px` : `${MINI_WIDTH}px`,
          transition: "all 0.3s ease-in-out",
          p: { xs: 1.5, md: 2.5 },
          minWidth: 0,
        }}
      >
        {/* Page content */}
        <Outlet />
      </Box>
    </Box>
  );
}
